import { defineMessages } from 'react-intl';

import { templatesOptions } from 'design-comuni-plone-theme/config/Blocks/ListingOptions';

const messages = defineMessages({
  show_tags: {
    id: 'parma_show_tags',
    defaultMessage: 'Mostra le categorie',
  },
});

export const addShowTagsOption = (schema, formData, intl, position = 0) => {
  let pos = position;

  pos = templatesOptions(
    schema,
    formData,
    intl,
    ['show_tags'],
    {
      show_tags: {
        default: false,
        label: intl.formatMessage(messages.show_tags),
      },
    },
    pos,
  );
  return pos;
};
